import Vue from 'vue'

export const state = () => ({
    default: false,
    small: false,
    large: false,
    modalTitle: '',
    modalContent: {
        title: '',
        message: '',
        link: {
            url: '',
            text: '',
        },
    },
    modalClass: 'callout-info',
});

export const mutations = {
    openDefault(state) {
        state.default = true;
    },
    closeDefault(state) {
        state.default = false;
    },
    setModalData(state, modalData) {
        state.modalTitle = modalData.title || 'モーダルタイトル';
        state.modalContent = modalData.content || {
            title: 'デフォルトタイトル',
            message: 'デフォルトメッセージ',
            link: {
                url: '#',
                text: 'デフォルトリンク',
            },
        };
        state.modalClass = modalData.class || 'callout-info';
    },
}
export const getters = {}
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
